import { ModalProps } from 'featureSliced/shared/store/reducers/ModalsReducer/types'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import {
  IBucketProduct,
  IProductWithBucketProduct,
} from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { UpdateProduct } from './modals/UpdateProduct'

export type OpenProductModalType = (
  product: IBucketProduct,
  categoryName?: string
) => void

export const useUpdateBucketProduct = (): OpenProductModalType => {
  const openModal = useOpenModal()
  const productsList = useMySelector((state) =>
    state.categories.items.flatMap((cat) => cat.products)
  )

  const openProductModal = (product: IBucketProduct) => {
    const getFullProduct = () => {
      const ogProduct = productsList?.find((p) => p.id === product.productId)
      return {
        ...ogProduct,
        ...product,
      }
    }

    openModal({
      id: `ADD_PRODUCT_${product.uniqueId}`,
      components: [
        ({ closeThisModal }: ModalProps) => (
          <UpdateProduct
            product={getFullProduct() as IProductWithBucketProduct}
            bucketProduct={product}
            closeProduct={closeThisModal}
          />
        ),
      ],
    })
  }

  return openProductModal
}
